import { GridLegacy as Grid } from '@mui/material';
import styled from 'styled-components';

export const HeaderGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 16px 20px;
  max-height: 60px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const Title = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.15px;
`;

export const TaskRecordContainer = styled.div<{ $editing?: boolean }>`
  padding: 16px 20px 20px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  padding-top: ${(props) => props.$editing && '0'};
  border-top: 0;
`;
